import { render, staticRenderFns } from "./PlanoAcidentePessoal.vue?vue&type=template&id=5b2e5b88&scoped=true"
import script from "./PlanoAcidentePessoal.vue?vue&type=script&lang=js"
export * from "./PlanoAcidentePessoal.vue?vue&type=script&lang=js"
import style0 from "./PlanoAcidentePessoal.vue?vue&type=style&index=0&id=5b2e5b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e5b88",
  null
  
)

export default component.exports